import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Footer extends React.PureComponent {
    static propTypes = { content: PropTypes.array };

    render() {
        const content = Array.isArray(this.props.content) ? [...this.props.content] : [];

        if (!content.length) return null;

        const copyrightData = content.pop() || {};

        return (
            <footer className={styles.footer}>
                <nav className={`${styles.foot_link} clearfix`} aria-label="页脚链接">
                    <div className={styles.list}>
                        {content.map((item, index) => (
                            <a key={index} className={styles.link} href={item.url} target="_blank" rel="noopener noreferrer">
                                {item.title}
                            </a>
                        ))}
                    </div>
                </nav>
                <div className={styles.copyright}>
                    <span>{copyrightData.text0}</span>
                    <span>{copyrightData.text1}</span>
                    <span>{copyrightData.text2}</span>
                </div>
            </footer>
        );
    }
}

export default errorBoundary(Footer);
